import { useEffect, useState } from 'react'
import JSZip from 'jszip'
import type { ArtBook } from '../definitions/ArtBook'
import type { CustomerOrderResult } from '../services/book'
import { constants } from '../constants'
import { bookService } from '../services/book'
import { setupFirebase, signInFirebaseAnonymously } from '../services/firebase'
import { queryBookResultToArtBook } from '../utils/queryBookResultToArtBook'
import { fetchOriginalImageBytes } from '../utils/urlToOriginalImage'
import { BookCover } from '../components/BookMockup'
import { ArrowIcon, SiteHeader, Spinner } from '../components/SiteShell'

export default function OrderPage() {
  const [book, setBook] = useState<ArtBook>()
  const [order, setOrder] = useState<CustomerOrderResult>()
  const [error, setError] = useState('')
  const [downloading, setDownloading] = useState(false)
  const orderId = new URLSearchParams(window.location.search).get(constants.searchParams.orderId)
  const checkoutSessionId = new URLSearchParams(window.location.search).get(constants.searchParams.checkoutSessionId) || undefined
  useEffect(() => {
    if (!orderId) { setError('This order link is missing its order number.'); return }
    setupFirebase()
    signInFirebaseAnonymously()
      .then(async () => {
        const orderResult = await bookService.queryOrder({ orderId, checkoutSessionId })
        const bookResult = await bookService.queryBook({ photoBookId: orderResult.photoBookId })
        setBook(queryBookResultToArtBook(bookResult))
        setOrder(orderResult)
      })
      .catch(() => setError('We couldn’t verify this order. Please contact support if the problem continues.'))
  }, [checkoutSessionId, orderId])
  async function download() {
    if (!book) return
    setDownloading(true)
    try {
      const zip = new JSZip()
      await Promise.all(book.pages.map(async (page, index) => {
        const image = await fetchOriginalImageBytes(page.generatedImageUrl)
        zip.file(`luciebook-${index + 1}.${image.extension}`, image.bytes)
      }))
      const blob = await zip.generateAsync({ type: 'blob' })
      const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = 'luciebook-portraits.zip'; link.click(); URL.revokeObjectURL(link.href)
    } catch (caught) { console.error(caught); setError('The download was interrupted. Please try again.') }
    finally { setDownloading(false) }
  }
  const paid = order?.isPaid === true
  const orderStatus = order?.gelatoOrderStatus || order?.orderStatus
  return <div className="studio-page"><SiteHeader simple onBack={() => window.location.assign('/')} /><main className="order-page"><section className="order-card"><div className="success-mark">{paid ? '✓' : '…'}</div><span className="eyebrow">{paid ? 'Payment confirmed' : 'Confirming payment'}</span><h1>{paid ? <>Your book is<br />being prepared.</> : <>Just a moment…<br />We’re checking your order.</>}</h1><p className="order-lead">{paid ? "We’re getting every page just right. We’ll email you as soon as your Lucie's Book leaves for home." : 'Please keep this page open while the secure payment result is confirmed.'}</p>{book && order ? <><BookCover title={book.cover.coverTitleTop} imageUrl={book.cover.generatedImageUrl} compact /><dl><div><dt>Order</dt><dd>{orderId}</dd></div><div><dt>Date</dt><dd>{book.createAt?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</dd></div>{orderStatus && <div><dt>Status</dt><dd>{orderStatus.replaceAll('_', ' ').toLowerCase()}</dd></div>}</dl>{paid && <button className="button button-full" onClick={download} disabled={downloading}>{downloading ? <><Spinner /> Preparing photos…</> : <>Download digital portraits <ArrowIcon /></>}</button>}</> : !error && <Spinner label="Verifying order" />}{error && <p className="form-error">{error}</p>}<a className="text-link" href="/studio/">Create another Lucie's Book <ArrowIcon /></a></section></main></div>
}
